/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `PROVIDER` - Provider
 * * `HEALTHCARE_ENTITY` - Hco
 * * `ACCOUNT` - User
 * * `STAFF` - Staff
 * * `EXTERNAL` - External
 */
export enum SignerAudienceEnum {
    PROVIDER = 'PROVIDER',
    HEALTHCARE_ENTITY = 'HEALTHCARE_ENTITY',
    ACCOUNT = 'ACCOUNT',
    STAFF = 'STAFF',
    EXTERNAL = 'EXTERNAL',
}
